module.exports = __webpack_public_path__ + "img/radius-setting.40f51ade.svg";